var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5fb832;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path55",
    className: "cls-1",
    d: "m90.36,71.75c-12.18,16.23-38.21,10.75-54.9,11.54,0,0-2.95.16-5.93.65,0,0,1.13-.48,2.56-.97,11.72-4.05,17.26-4.87,24.38-8.53,13.38-6.85,26.7-21.78,29.41-37.29-5.09,14.92-20.58,27.76-34.69,32.97-9.65,3.56-27.11,7.03-27.11,7.03,0,.01-.7-.37-.71-.37-11.87-5.78-12.22-31.49,9.35-39.78,9.45-3.64,18.5-1.64,28.72-4.07,10.9-2.59,23.53-10.76,28.66-21.45,5.75,17.06,12.66,43.76.27,60.27Zm.21-65.56c-1.45,3.45-3.22,6.55-5.26,9.33C76.33,6.31,63.79.56,49.94.56,22.68.56.5,22.74.5,50c0,14.29,6.1,27.17,15.82,36.21l1.08.96c-1.81-1.47-2.09-4.13-.62-5.94,1.47-1.81,4.13-2.09,5.94-.62,1.81,1.47,2.09,4.13.62,5.94-1.46,1.81-4.13,2.09-5.94.62l.74.65c8.6,7.24,19.69,11.62,31.79,11.62,26.06,0,47.45-20.28,49.28-45.87,1.36-12.53-2.35-28.44-8.64-47.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpring);
export default __webpack_public_path__ + "static/media/spring.5b6b7b1cbf9d68354ccb89992558960a.svg";
export { ForwardRef as ReactComponent };